import HeaderHero from "../Contact/HeaderHero";
import Profile from "./Profile";
import Statistic from "./Statistic";
import Team from "./Team";
import WantWebsite from "./WantWebsite";
import WhyChoose from "./WhyChosse";
import Message from "../Message";
import { useEffect } from "react";
function About(){
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <>
        <HeaderHero Name={'About Us'}/>
        <Profile/>  
        <WhyChoose/>      
        <WantWebsite/>
        <Statistic/>
        <Team/>
        <Message/>        
        </>
    )
}
export default About;